<template>
    <div class="context-wrapper">
        <div class="content-body">
            <b-row>
                <b-col
                    md="12"
                    xl="6"
                >
                    <b-overlay
                        :show="status.common === 'loading'"
                    >
                        <b-card
                            no-body
                        >
                            <div class="card-header">
                                <div
                                    class="card-group-title"
                                >
                                    <h4>{{ $t("org.billing.Data Usage Trend") }}</h4>
                                </div>
                            </div>
                            <DataTransfersInOutDailyChart
                                :themeColors="themeColors"
                                :theme="theme"
                                :data="inOutDates"
                                xKey="date"
                            />
                            <DataTransfersInOutDailyList
                                :themeColors="themeColors"
                                :data="inOutDates"
                            />
                        </b-card>
                    </b-overlay>
                </b-col>
                <b-col
                    md="12"
                    xl="6"
                >
                    <b-overlay
                        :show="status.common === 'loading'"
                    >
                        <b-card
                            no-body
                        >
                            <div class="card-header">
                                <div
                                    class="card-group-title"
                                >
                                    <h4>{{ $t("org.billing.Traffic flow chart") }}</h4>
                                </div>
                            </div>
                            <DataTransfersFlowChart
                                :data="transferItems"
                            />
                            <DataTransfersFlowTable
                                :data="transferItems"
                            />
                        </b-card>
                    </b-overlay>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-overlay
                        :show="status.common === 'loading'"
                    >
                        <b-card
                            no-body
                        >
                            <div class="card-header">
                                <div
                                    class="card-group-title"
                                >
                                    <h4>{{ $t("org.billing.Detailed Traffic by Resource") }}</h4>
                                </div>
                            </div>
                            <DataTransfersResourceList
                                :data="transferResourceIdsForCurrentPage"
                                :lengthsOfTransferResourceIds="lengthsOfTransferResourceIds"
                                :checkboxModels="checkboxModels"
                                :projectIdx="project.projectIdx"
                                :month="month"
                                @api:getDataTransfersResourceId="getDataTransfersResourceId"
                            />
                        </b-card>
                    </b-overlay>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { getCurrentInstance, computed, inject, watch, ref, toRefs } from '@vue/composition-api'
import DataTransfersInOutDailyChart from './_components/DataTransfersInOutDailyChart'
import DataTransfersInOutDailyList from './_components/DataTransfersInOutDailyList'
import DataTransfersFlowChart from './_components/DataTransfersFlowChart'
import DataTransfersFlowTable from './_components/DataTransfersFlowTable'
import DataTransfersResourceList from './_components/DataTransfersResourceList'
export default {
    name: 'DataTransfersModule',
    props: ['project', 'month'],
    data () {
        return {
            open: false
        }
    },
    components: {
        DataTransfersInOutDailyChart,
        DataTransfersInOutDailyList,
        DataTransfersFlowChart,
        DataTransfersFlowTable,
        DataTransfersResourceList
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const themeColors = inject('themeColors')
        const theme = inject('theme')
        const { project, month } = toRefs(props)
        const open = ref(false)
        const status = computed(() => store.getters['$_dataTransfers/status'])
        const inOutDates = computed(() => store.getters['$_dataTransfers/inOutDates'])
        const transferItems = computed(() => store.getters['$_dataTransfers/transferItems'])
        const lengthsOfTransferResourceIds = computed(() => store.getters['$_dataTransfers/lengthsOfTransferResourceIds'])
        const transferResourceIdsForCurrentPage = computed(() => store.getters['$_dataTransfers/transferResourceIdsForCurrentPage'])
        const checkboxModels = computed(() => store.getters['$_dataTransfers/checkboxModels'])
        const getDataTransfers = ({ projectIdx, month }) => store.dispatch('$_dataTransfers/getDataTransfers', { projectIdx, month })
        const getDataTransfersResourceId = (params) => store.dispatch('$_dataTransfers/getDataTransfersResourceId', params)
        const showDescription = () => { open.value = !open.value }
        watch(project, (value, oldValue) => {
            getDataTransfers({ projectIdx: value.projectIdx, month: month.value })
        }, {
            deep: true
        })
        watch(month, (value, oldValue) => {
            getDataTransfers({ projectIdx: project.value.projectIdx, month: value })
        })

        return {
            themeColors,
            theme,
            status,
            inOutDates,
            transferItems,
            lengthsOfTransferResourceIds,
            transferResourceIdsForCurrentPage,
            checkboxModels,
            getDataTransfersResourceId,
            showDescription
        }
    }
}
</script>

<style>

</style>
